import React, { useEffect } from "react";
import TopBar from "../components/landing/TopBar";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import UniqueFeatures from "../components/landing/UniqueFeatures";
import FeaturesPage from "../components/landing/FeaturesPage";
import Clients from "../components/landing/Clients";
import Footer from "../components/landing/Footer";
import "../components/landing/landing.css";

export default function LandingPage() {
    useEffect(() => {
        document.body.classList.add('landing-page');
        return () => {
            document.body.classList.remove('landing-page');
        };
    }, []);

    return (
        <>
            <TopBar />
            <Header />
            <Hero />
            <Features />
            <UniqueFeatures />
            <FeaturesPage />
            <Clients />
            <Footer />
        </>
    );
}